import React, { useEffect, useState } from "react";
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import productsDb from "../../../../mocks/db/products.db";
import Table, { TBody, Td, TFoot, Th, THead, Tr } from "../../../../components/ui/Table";
import Icon from "../../../../components/icon/Icon";
import { CardBody, CardHeader, CardHeaderChild, CardTitle } from "../../../../components/ui/Card";
import { TableCardFooterTemplate } from "../../../../templates/common/TableParts.template";
import TableSkeletonLoader from "../../../../components/loader/skeleton/tableSkeletonLoader";
import AddMachineModel from "../../../../components/admin/home/addMachineModel";
import Button from "../../../../components/ui/Button";
import { useNavigate } from "react-router-dom";
import AdvertisementsModel from "../model/advertisementsModel";
import { addDays, currencyFormat, formatDate, logoutFun } from "../../../../utils/helper";
import { GetPictureByContext } from "../../../../services/vizyBilityServices";
// import { useMsal } from "@azure/msal-react"; // Azure B2C - temporarily disabled
import Tooltip from "../../../../components/ui/Tooltip";
import Badge from "../../../../components/ui/Badge";
import classNames from "classnames";


const defaultData = [productsDb[0], productsDb[1], productsDb[2]];

const columnHelper = createColumnHelper();

const TablePartial = ({ isLoading, machineData, pagination, setPageSize, setPageIndex, handleResetPagination }) => {
  const navigate = useNavigate();
  // const { instance, accounts } = useMsal(); // Azure B2C - temporarily disabled

  const azureUserInfo = localStorage.getItem("getAzureUserData")
    ? JSON.parse(localStorage.getItem("getAzureUserData") || {})
    : null;

  const [sorting, setSorting] = React.useState([]);
  const [modalStatus, setModalStatus] = useState(false);
  const [editMachineInfo, setEditMachineInfo] = useState({});
  const [advertisementsModel, setAdvertisementsModel] = useState(false);
  const [editAssetID, setEditAssetID] = useState(null);
  const [editAssetData, setEditAssetData] = useState(null); // Add state for asset data
  const [images, setImages] = useState([]);
  const [advertisementValue, setAdvertisementsValue] = useState({
    AssetAdvertisementId: null,
    AdvertisedPrice: "",
    AdvertisedCurrency: "USD",
    AdDescription: "",
    ContactName: azureUserInfo?.givenName || "",
    ContactEmail: azureUserInfo?.identities?.find((item) => item.signInType === "emailAddress")?.issuerAssignedId || "",
    ContactPhone: azureUserInfo?.Phone || "",
    AdStartDate: formatDate(new Date()),
    AdEndDate: formatDate(addDays(new Date(), 30)),
    SortOrder: 1,
    Featured: false,
    Enabled: true, // Temp comment
    AdvertiserIds: [1],
  });

  const GetAssetImgs = (editAssetID) => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    const query = `context=Asset&contextId=${editAssetID}`;

    GetPictureByContext(query, header)
      .then((res) => {
        // setCompanyImg(res.data);

        let ImageList = [];
        res.data?.map((item, index) => {
          ImageList.push({
            ...item,
            New: false,
            preview: item?.url,
            sortCount: index,
          });
        });
        setImages(ImageList);
      })
      .catch((err) => {
        if (err?.status == 401 || err?.statusText == "Unauthorized") {
          logoutFun();
        }
      });
  };
  const formatDateTime = (dateTime) => {
    const date = new Date(dateTime);
    const formattedDate = date.toLocaleDateString(); // Format as "MM/DD/YYYY"
    const formattedTime = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }); // Format as "HH:MM AM/PM"
    return { formattedDate, formattedTime };
  };
  useEffect(() => {
    if (!modalStatus) setEditMachineInfo({});
  }, [modalStatus]);

  const columns = [
    columnHelper.accessor("AssetPictureUrl", {
      cell: (info) => {
        const currentDate = formatDate(new Date());
        const startDate = info?.row?.original?.AdStartDate;
        const endDate = info?.row?.original?.AdEndDate;

        let status = null;
        // let isActive = false;

        if (startDate && endDate) {
          if (currentDate > endDate) {
            status = { text: "P", color: "bg-red-500" };
          } else if (currentDate < startDate) {
            status = { text: "F", color: "bg-yellow-500" };
          } else if (currentDate >= startDate && currentDate <= endDate) {
            status = { text: "C", color: "bg-green-500" };
            // isActive = true;
          }
        }

        const tooltipContent = startDate && endDate ? (
          <div className="text-xs font-medium">
            <div className="mb-1">From this: {formatDateTime(startDate).formattedDate}</div>
            <div>To this: {formatDateTime(endDate).formattedDate}</div>
          </div>
        ) : null;

        return (
          <div className="flex items-center justify-start gap-[1rem] px-2">
            <div className="flex h-5 w-5 flex-shrink-0 items-center justify-center">
              {status && (
                <Tooltip
                  text={tooltipContent}
                  placement="top"
                  className="!bg-zinc-800 dark:!bg-zinc-900 !text-white !border-zinc-700"
                >
                  <span className="relative flex h-2.5 w-2.5 md:h-4 md:w-4 items-center justify-center">
                    {status.text === "C" && (
                      <span
                        className={classNames(
                          "animate-ping absolute inline-flex h-full w-full rounded-full opacity-75",
                          status.color.replace("500", "400")
                        )}
                      />
                    )}
                    <span className={classNames("relative inline-flex rounded-full h-2.5 w-2.5 md:h-4 md:w-4", status.color)} />
                  </span>
                </Tooltip>
              )}
            </div>
            <div className="flex-shrink-0">
              {info?.row?.original?.AssetPictureUrl ? (
                <img
                  className="aspect-[9/12] w-14 h-14 rounded object-cover 2xl:w-20 2xl:h-20"
                  src={info?.row?.original?.AssetPictureUrl}
                  alt="asset"
                />
              ) : (
                <div className="aspect-[9/12] w-14 h-14 2xl:w-20 2xl:h-20 rounded bg-gray-200 dark:bg-zinc-800 flex items-center justify-center text-xs text-gray-500">
                  No Image
                </div>
              )}
            </div>
          </div>
        );
      },
      header: "Image",
      footer: "Image",
      headerClassName: "text-center",
    }),
    columnHelper.accessor("Unit Number", {
      cell: (info) => <div className="text-sm text-center">{info?.row?.original?.UnitNumber || "-"}</div>,
      header: "Unit Number",
      footer: "Unit Number",
      headerClassName: "text-center",
    }),
    columnHelper.accessor("Year", {
      cell: (info) => <div className="text-sm text-center">{info?.row?.original?.Year || "-"}</div>,
      header: "Year",
      footer: "Year",
      headerClassName: "text-center",
    }),
    columnHelper.accessor("Make", {
      cell: (info) => <div className="text-sm text-center">{info?.row?.original?.MakeName || "-"}</div>,
      header: "Make",
      footer: "Make",
      headerClassName: "text-center",
    }),
    columnHelper.accessor("Model", {
      cell: (info) => <div className="text-sm text-center">{info?.row?.original?.Model || "-"}</div>,
      header: "Model",
      footer: "Model",
      headerClassName: "text-center",
    }),
    columnHelper.accessor("Serial Number", {
      cell: (info) => <div className="text-sm text-center">{info?.row?.original?.SerialNumber || "-"}</div>,
      header: "Serial Number",
      footer: "Serial Number",
      headerClassName: "text-center",
    }),
    columnHelper.accessor("Machine SMU", {
      cell: (info) => (
        <div className="text-sm text-center">
          {info?.row?.original?.TotalMachineSmu
            ? `${info?.row?.original?.TotalMachineSmu} ${info?.row?.original?.Smuunits ? info?.row?.original?.Smuunits : "Hours"
            }`
            : info?.row?.original?.idle_hours || "-"}
        </div>
      ),
      header: "Machine SMU",
      footer: "Machine SMU",
      headerClassName: "text-center",
    }),
    columnHelper.accessor("Price", {
      cell: (info) => (
        <div className="text-sm text-center">
          {" "}
          {info?.row?.original?.Price
            ? `${info?.row?.original?.AdvertisedCurrency
              ? info?.row?.original?.AdvertisedCurrency === "USD" ||
                info?.row?.original?.AdvertisedCurrency === "CAD"
                ? "$"
                : ""
              : ""
            }${currencyFormat(Number(info?.row?.original?.Price))}`
            : "-"}
        </div>
      ),
      header: "Price",
      footer: "Price",
      headerClassName: "text-center",
    }),
    columnHelper.accessor("Location Name", {
      cell: (info) => (
        <Tooltip text={info?.row?.original?.LocationName || ""}>
          <div className="text-sm text-center max-w-[200px] truncate">
            {info?.row?.original?.LocationName || "-"}
          </div>
        </Tooltip>
      ),
      header: "Location Name",
      footer: "Location Name",
      headerClassName: "text-center",
      size: 200,
      maxSize: 200,
    }),

    columnHelper.accessor("Action", {
      cell: (info) => (
        <div className="text-sm flex text-center  justify-center whitespace-nowrap">
          <div
            className="text-[#0EA5E9] cursor-pointer border-r pr-[5px]"
            onClick={() => {
              navigate(`/admin/edit-machine/${info?.row?.original.AssetId}`, {
                state: { editMachineInfo: info?.row?.original },
              });
            }}
          >
            Edit
          </div>
          <div
            onClick={() => {
              setEditAssetID(info?.row?.original.AssetId);
              setEditAssetData(info?.row?.original); // Pass asset data
              GetAssetImgs(info?.row?.original.AssetId);
              setAdvertisementsModel(true);
            }}
            className="text-[#FEBA06] pl-[5px] cursor-pointer"
          >
            Sell
          </div>
        </div>
      ),
      header: "Action",
      footer: "Action",
      headerClassName: "text-center",
      size: 130,
      minSize: 130,
      meta: {
        sticky: "right",
      },
    }),
  ];

  const handleCloseMachinePopUp = () => {
    setModalStatus(false);
  };

  const table = useReactTable({
    data: machineData,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    // debugTable: true,
  });

  return (
    <>
      <div className="flex justify-between">
        <CardHeader>
          <CardHeaderChild>
            <CardTitle>My Equipment Assets</CardTitle>
            {/* Status Badges */}
            <div className="flex gap-2 items-center flex-wrap">

              {/* Expired */}
              <span className="flex items-center gap-1 px-3 py-1 rounded-md bg-red-100 text-red-700 text-sm font-medium">
                <span className="h-2 w-2 rounded-full bg-red-500"></span>
                Expired
              </span>

              {/* Current */}
              <span className="flex items-center gap-1 px-3 py-1 rounded-md bg-green-100 text-green-700 text-sm font-medium">
                <span className="relative flex h-2 w-2">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-400 opacity-75" />
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-green-500" />
                </span>
                Current
              </span>

              {/* Future */}
              <span className="flex items-center gap-1 px-3 py-1 rounded-md bg-yellow-100 text-yellow-700 text-sm font-medium">
                <span className="h-2 w-2 rounded-full bg-yellow-500"></span>
                Future
              </span>

            </div>
          </CardHeaderChild>
        </CardHeader>
        <div className="m-[14px] text-end">
          <Button
            className="!bg-[#FEBA06] border-none !text-black px-[20px] py-[12px] rounded-xl font-medium"
            onClick={() => navigate(`/admin/add-machine`)}
          >
            Add Machine
          </Button>
        </div>
      </div>
      <CardBody className="overflow-auto">
        <div className="w-full">
          <div className="overflow-x-auto">
            <Table className="min-w-[1200px]">
              <THead>
                {table.getHeaderGroups().map((headerGroup) => (
                  <Tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => (
                      <Th
                        key={header?.id}
                        isColumnBorder={false}
                        style={{
                          width: header.getSize(),
                          ...(header.column.columnDef.meta?.sticky === 'right' && {
                            position: 'sticky',
                            right: 0,
                            // zIndex: 10,
                          })
                        }}
                        isResizable={header.column.getIsResizable?.()}
                        className={`text-left ${header.column.columnDef.meta?.sticky === 'right' ? '!bg-gray-50 dark:!bg-[#09090b] shadow-[-4px_0_6px_-2px_rgba(0,0,0,0.3)]' : ''}`}
                      >
                        {header?.isPlaceholder ? null : (
                          <div
                            key={header.id}
                            aria-hidden="true"
                            {...{
                              className: header.column.getCanSort()
                                ? "cursor-pointer select-none flex items-center justify-center text-center"
                                : "",
                              onClick: header.column.getToggleSortingHandler(),
                            }}
                          >
                            {flexRender(header.column.columnDef.header, header.getContext())}
                            {{
                              asc: <Icon icon="HeroChevronUp" className="ltr:ml-1.5 rtl:mr-1.5" />,
                              desc: <Icon icon="HeroChevronDown" className="ltr:ml-1.5 rtl:mr-1.5" />,
                            }[header.column.getIsSorted()] ?? null}
                          </div>
                        )}
                      </Th>
                    ))}
                  </Tr>
                ))}
              </THead>
              <TBody>
                {!isLoading ? (
                  Number(pagination?.totalRecords) <= 0 ? (
                    <Tr>
                      <Td className="text-center py-[100px] font-normal text-[30px]" colspan="11">
                        No Record Found
                      </Td>
                    </Tr>
                  ) : (
                    table.getRowModel().rows.map((row) => (
                      <Tr key={row.id}>
                        {row.getVisibleCells().map((cell) => (
                          <Td
                            key={cell.id}
                            style={{
                              ...(cell.column.columnDef.meta?.sticky === 'right' && {
                                position: 'sticky',
                                right: 0,
                                // zIndex: 10,
                              })
                            }}
                            className={cell.column.columnDef.meta?.sticky === 'right' ? 'shadow-[-4px_0_6px_-2px_rgba(0,0,0,0.3)] !bg-white group-even/Tr:!bg-zinc-100 dark:!bg-[#18181b] dark:group-even/Tr:!bg-[#121214]' : ''}
                          >
                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                          </Td>
                        ))}
                      </Tr>
                    ))
                  )
                ) : (
                  [...Array(pagination?.showRecords)].map((_, index) => (
                    <Tr className="bg-gray-100">
                      <TableSkeletonLoader length={10} />
                    </Tr>
                  ))
                )}
              </TBody>
              <TFoot>
                {table.getFooterGroups().map((footerGroup) => (
                  <Tr key={footerGroup.id}>
                    {footerGroup.headers.map((header) => (
                      <Th
                        key={header.id}
                        isColumnBorder={false}
                        style={{
                          width: header.getSize(),
                          ...(header.column.columnDef.meta?.sticky === 'right' && {
                            position: 'sticky',
                            right: 0,
                            zIndex: 10,
                          })
                        }}
                        isResizable={header.column.getIsResizable?.()}
                        className={`text-left ${header.column.columnDef.meta?.sticky === 'right' ? '!bg-gray-50 dark:!bg-[#09090b] shadow-[-4px_0_6px_-2px_rgba(0,0,0,0.3)]' : ''}`}
                      >
                        {header.isPlaceholder ? null : (
                          <div
                            key={header.id}
                            aria-hidden="true"
                            {...{
                              className: header.column.getCanSort()
                                ? "cursor-pointer select-none flex items-center  justify-center"
                                : "",
                              onClick: header.column.getToggleSortingHandler(),
                            }}
                          >
                            {flexRender(header.column.columnDef.header, header.getContext())}
                            {{
                              asc: <Icon icon="HeroChevronUp" className="ltr:ml-1.5 rtl:mr-1.5" />,
                              desc: <Icon icon="HeroChevronDown" className="ltr:ml-1.5 rtl:mr-1.5" />,
                            }[header.column.getIsSorted()] ?? null}
                          </div>
                        )}
                      </Th>
                    ))}
                  </Tr>
                ))}
              </TFoot>
            </Table>
          </div>
        </div>
      </CardBody>
      <TableCardFooterTemplate
        table={table}
        pagination={pagination}
        setPageSize={setPageSize}
        setPageIndex={setPageIndex}
      />

      {/* Edit Machine Model */}

      {advertisementsModel && (
        <AdvertisementsModel
          modalStatus={advertisementsModel}
          setModalStatus={setAdvertisementsModel}
          AssetId={editAssetID}
          assetData={editAssetData}
          setAdvertisementsValue={setAdvertisementsValue}
          advertisementValue={advertisementValue}
          images={images}
          setImages={setImages}
        />
      )}

      <AddMachineModel
        handleResetPagination={handleResetPagination}
        handleCloseMachinePopUp={handleCloseMachinePopUp}
        modalStatus={modalStatus}
        setModalStatus={setModalStatus}
        editMachineInfo={editMachineInfo}
      />
    </>
  );
};

export default TablePartial;
